import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";
import { useTranslation } from "react-i18next";
import LanguageTranslator from '../../../../components/LanguageSelector';
function FootNav({ from }) {
  console.log(from, 'from');
  const { t } = useTranslation();
  return (
    <>
      {from === undefined ? "" :
      <div style={{ position: 'fixed', bottom: '12px', right: '20px', zIndex: 300 }} className="d-none d-md-block">
        <button className="bg-white shadow-sm border-0 rounded-5 px-2">
          <LanguageTranslator />
        </button>
      </div>
      }
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-links">
            <Link to="/about" state={'FooterMain'}>{t('about')}</Link>
            <Link to="/contact">{t('contact')}</Link>
            <Link to="/mission">{t('mission')}</Link>
            <Link to="/demo">{t('demo')}</Link>
            <Link to="/press">{t('press')}</Link>
            <Link to="/blog">{t('blog')}</Link>
            <Link to="/privacy-policy">{t('privacy')}</Link>
            <Link to="/terms-of-service">{t('terms')}</Link>
          </div>
        </div>
      </footer>
    </>
  );
}

export default FootNav;